module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-100-Classes-Active-36e3c3a4d4e0898bb1dc3c9a28932779.png";